import { render, staticRenderFns } from "./ParentPage.vue?vue&type=template&id=6a56cd17"
import script from "./ParentPage.vue?vue&type=script&lang=js"
export * from "./ParentPage.vue?vue&type=script&lang=js"
import style0 from "./ParentPage.vue?vue&type=style&index=0&id=6a56cd17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports